module.exports = __webpack_public_path__ + "assets/img/step6.7550db26.jpg";